<app-modal [maskClose]="maskClose" [id]="modalId">
  <aside class="modal confirm-modal">
    <div class="modal-body">
      <div [ngClass]="(amazonError)?'amazon-header':'header'">
        @if (title) {
          <p>{{title}}</p>
        }
        @if (!title) {
          <p>Error!</p>
        }
        <div class="button regular close" (click)="close(modalId)"><span class="icon">&#x00D7;</span></div>
      </div>
      <div class="content">
        @for (line of text; track line) {
          <p [innerHtml]="line | keepHtml"></p>
        }
        @if (_soldOutExtra && _soldOutExtra.length) {
          <ul>
            @for (extra of _soldOutExtra; track extra) {
              <li>{{extra}}</li>
            }
          </ul>
        }
      </div>
      <div [ngClass]="(amazonError)?'amazon-footer':'footer'">
        @if (!amazonError && !soldOut && _extraButtonType !== 'object') {
          <button class="button regular solid-red" (click)="close(modalId)">
            {{title ?  'Got it.' : closeText}}
          </button>
        }
        @if (soldOut) {
          <button class="button regular" (click)="closeAndGo(modalId)">Pick Another Date</button>
        }
        @if (amazonError) {
          <button class="button regular" (click)="close(modalId)">Continue Entering Book Info</button>
        }
        @if (_extraButtons === 'forgot') {
          <a routerLink="/forgot-password"><button type="button" class="button regular">Forgot Password</button></a>
        }
        @if (_extraButtons === 'login') {
          <a routerLink="/login"><button type="button" class="button regular">Login</button></a>
        }
        @if (_extraButtons && _extraButtons.length) {
          <div>
            @for (button of _extraButtons; track button) {
              <a (click)="button.callback && button.callback()">
                <button type="button" class="button regular" [ngClass]="button.class">
                  {{button.text}}
                </button>
              </a>
            }
          </div>
        }
      </div>
    </div>
  </aside>
  <div class="confirm-modal-background"></div>
</app-modal>
